import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import EmbeddedIFrame from 'components/atoms/EmbeddedIFrame';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import PageTitle from 'hoc/PageTitle';
import { ADMINAREA_ACCESS, REDASH_TOOLS_DUPLICATE_DASHBOARD } from 'constants/capabilities';

const DuplicateRedashDashboardPage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer title="Redash Tools" admin hideDatePicker />}>

        <EmbeddedIFrame
            src={props.config.env.REACT_APP_REDASH_TOOLS_DUPLICATE_DASHBOARD_URL}
            width="100%"
        />
    </AdminTemplate>
);

const mapStateToProps = state => ({
    config: state.config
});

export default compose(
    PageTitle({ pageTitle: 'Redash Tools', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [REDASH_TOOLS_DUPLICATE_DASHBOARD, ADMINAREA_ACCESS] }),
    connect(mapStateToProps),
)(DuplicateRedashDashboardPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/redash/DuplicateRedashDashboardPage.js